<template>
  <v-data-table
    :headers="headers"
    :items="appointmentsList"
    height="auto"
    class="elevation-1"
    no-data-text="Sin resultados disponibles"
    fixed-header
    :footer-props="{
      'items-per-page-text': 'Elementos por página',
      'items-per-page-all-text': 'Todo',
      'items-per-page-options': [10],
    }"
  >
    <template v-slot:[`item.actions`]="{ index }">
      <v-tooltip v-if="isDelete" top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            small
            class="mr-2"
            @click="deleteAppointment(index)"
            v-bind="attrs"
            v-on="on"
          >
            mdi mdi-delete
          </v-icon>
        </template>
        <span>Eliminar</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.guide`]="{ index }">
      <div>
        {{ index + 1 }}
      </div>
    </template>
    <template v-slot:[`item.selectTreatments`]="{ value }">
      <div v-for="(item, index) in value" :key="index">
        {{ item.text }}
      </div>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    appointmentsList: {
      type: Array,
    },
    deleteAppointment: Function,
  },
  data() {
    return {
      isDelete: true,
      headers: [
        { text: "#", value: "guide" },
        { text: "Especialidad", value: "speciality.name" },
        { text: "Modalidad", value: "modality.name" },
        { text: "Perfil de estudio", value: "studyProfile.name" },
        { text: "Acciones", value: "actions", sortable: false, width: "10%" },
      ],
    };
  },
  methods: {},
};
</script>
